/**
 * ModalCloseButton — shared always-visible modal close (✕) control.
 *
 * Preferred: place as a flex sibling inside the modal header
 * (header: display flex; justify-content space-between; align-items center).
 * Example: <ModalCloseButton onClick={...} title="Close" />
 *
 * Optional `corner` keeps absolute top-right placement for backward
 * compatibility (parent must be position: relative). Prefer header placement.
 */

import React from 'react';
import './ModalCloseButton.css';

function ModalCloseButton({
  onClick,
  title = 'Close',
  disabled = false,
  corner = false,
  className = '',
  ...rest
}) {
  const classes = [
    'modal-close-control',
    corner ? 'modal-close-control--corner' : '',
    className,
  ]
    .filter(Boolean)
    .join(' ');

  return (
    <button
      type="button"
      className={classes}
      onClick={onClick}
      title={title}
      aria-label={title}
      disabled={disabled}
      {...rest}
    >
      ✕
    </button>
  );
}

export default ModalCloseButton;
